<template>
  <div class="row mb-3">
    <configuracao :intTipoDocumentoId="280" :key="$root.$session.versao" />
  </div>
</template>

<script>
import Configuracao from "@/components/documento/pgr/configuracao/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { Configuracao },
  beforeDestroy() {},
  mounted() {},
  created() {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
};
</script>
